import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ChristmasLogoGif, CincoDeMayoGif, CrmLogo, CrmLogo4thJuly, CrmLogoHalloween, EasterLogoGif, MenuIcon, ThanksgivingLogoGif } from "../../../icons";
import { MenuItem } from "../../../views/MainScreen";
import { Autocomplete } from "../../autocomplete/Autocomplete";
import { Module } from "../navbar/Module";
import Notifications from "../navbar/Notifications";
import { User } from "../navbar/User";
import SidebarLink from "./SidebarLink";
import { isIn4thOfJulyRange, isInChristmasRange, isInCincoDeMayoRange, isInEasterRange, isInHalloweenRange, isInThanksgivingRange } from "../../../utils";

export type SidebarProps = {
    menu: MenuItem[];
};

function Sidebar({ menu }: SidebarProps) {
    const [toggle, setToggle] = useState(false);
    const Logo = useMemo(() => {
        if (isInChristmasRange(new Date())) return <img src={ChristmasLogoGif} className="w-[61px] h-[45px]" alt="Christmas Logo" />
        if (isIn4thOfJulyRange(new Date())) return <CrmLogo4thJuly className="size-[45px]" />
        if (isInHalloweenRange(new Date())) return <CrmLogoHalloween className="size-[45px]" />
        if (isInThanksgivingRange(new Date())) return <img src={ThanksgivingLogoGif} className="w-[61px] h-[45px]" alt="Thanksgiving Logo" />
        if (isInEasterRange(new Date())) return <img src={EasterLogoGif} className="w-[61px] h-[45px]" alt="Easter Logo" />
        if (isInCincoDeMayoRange(new Date())) return <img src={CincoDeMayoGif} className="w-[61px] h-[45px]" alt="Cinco de Mayo Logo" />
        return <CrmLogo className="fill-current !text-color8 transition-all size-[35px]" />;
    }, [])

    return (
        <div className="overflow-visible">
            <div className="md:hidden flex justify-start bg-color1 sticky top-0 z-50">
                <div className="w-full flex items-center">
                    <MenuIcon
                        onClick={() => setToggle(!toggle)}
                        className="text-color8 md:hidden  fill-current w-10 h-10 cursor-pointer m-2"
                    />
                    <Autocomplete />
                </div>
                <div className="ml-auto flex items-center w-3/5 justify-end gap-x-2">
                    <Module />
                    <Notifications />
                    <User />
                </div>
            </div>
            <div
                className={`flex flex-col bg-color1 overflow-visible  overflow-y-auto scrollbar-hide md:sticky text-color8 md:h-screen md:top-0
        font-inter font-normal text-r-large md:min-h-screen transition-all  ${toggle ? " sticky top-[var(--sidebar-height-mobile)] body-scroll-none h-screen" : ""
                    } `}
            >
                <Link
                    to="/dashboard"
                    className={`md:flex overflow-visible flex transition-all items-center sidebar-link min-h-[55px]`}
                >
                    <div
                        className={`relative flex overflow-visible w-full h-full justify-center bg-color1 items-center`}
                    >
                        {Logo}
                    </div>
                </Link>
                <div
                    className={`transition-all overflow-visible flex flex-col ${toggle ? "" : "h-0"
                        }`}
                >
                    {menu.map((item) => {
                        return (
                            <SidebarLink
                                toggleFunction={setToggle}
                                name={item.name}
                                url={item.url}
                                Icon={item.icon}
                                key={`sidebar-link-${item.name}`}
                                active={item.active}
                                tooltip={item.tooltip}
                                notifications={item.notification}
                            />
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
